var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hide)?_c('Loading'):_c('router-view'),_c('el-backtop',{staticStyle:{"color":"var(--titleColor)"}}),_c('Tip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }